// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container_button__yOHQn{
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .styles_button_next__B\\+9H5 {
    background-color: #18316e !important;
    color: #ffffff !important;
    font-family: "Inter" !important;
    font-weight: 400 !important;
    padding: .4rem 1.5rem !important;
    text-transform: none !important;
    transition: all 0.3s ease !important;
  }
  
  .styles_button_next__B\\+9H5:hover {
    transform: scale(0.95) !important;
    opacity: 0.9;
  }

  .styles_button_back__QiCZi {
    background-color: #fff !important;
    border: 1px solid #18316e !important;
    color: #18316e !important;
    font-family: "Inter" !important;
    font-weight: 400 !important;
    padding: .4rem 1.5rem !important;
    text-transform: none !important;
    transition: all 0.3s ease !important;
  }
  
  .styles_button_back__QiCZi:hover {
    transform: scale(0.95) !important;
    opacity: 0.9;
  }`, "",{"version":3,"sources":["webpack://./src/components/CadastroDetalhado/ResponsavelEmpresa/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,2BAA2B;IAC3B,gCAAgC;IAChC,+BAA+B;IAC/B,oCAAoC;EACtC;;EAEA;IACE,iCAAiC;IACjC,YAAY;EACd;;EAEA;IACE,iCAAiC;IACjC,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,2BAA2B;IAC3B,gCAAgC;IAChC,+BAA+B;IAC/B,oCAAoC;EACtC;;EAEA;IACE,iCAAiC;IACjC,YAAY;EACd","sourcesContent":[".container_button{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .button_next {\n    background-color: #18316e !important;\n    color: #ffffff !important;\n    font-family: \"Inter\" !important;\n    font-weight: 400 !important;\n    padding: .4rem 1.5rem !important;\n    text-transform: none !important;\n    transition: all 0.3s ease !important;\n  }\n  \n  .button_next:hover {\n    transform: scale(0.95) !important;\n    opacity: 0.9;\n  }\n\n  .button_back {\n    background-color: #fff !important;\n    border: 1px solid #18316e !important;\n    color: #18316e !important;\n    font-family: \"Inter\" !important;\n    font-weight: 400 !important;\n    padding: .4rem 1.5rem !important;\n    text-transform: none !important;\n    transition: all 0.3s ease !important;\n  }\n  \n  .button_back:hover {\n    transform: scale(0.95) !important;\n    opacity: 0.9;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_button": `styles_container_button__yOHQn`,
	"button_next": `styles_button_next__B+9H5`,
	"button_back": `styles_button_back__QiCZi`
};
export default ___CSS_LOADER_EXPORT___;
